export const getStoredAuthToken = () => localStorage.getItem('authToken');

export const storeAuthToken = (token) =>
  localStorage.setItem('authToken', token);

export const removeStoredAuthToken = () => localStorage.removeItem('authToken');

export const setAuthErrorValue = (key, value) =>
  window.localStorage.setItem(key, value);

export const getStoredAuthError = () => localStorage.getItem('authError');

// export const AuthErrors = {
//     username: 'username is required',
//     password: 'password is required',
//     provider: 'provider is required'
//   };
